import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { Locales } from 'gw-js-lib';

Vue.use(VueI18n);

export default new VueI18n({
  locale: process.env.VUE_APP_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_LOCALE || 'en',
  messages: Locales.Locales,
});
